import React, { useEffect } from 'react';
import './about.css';
import banner from '../assets/Banner/banner_suit.jpg';
import craft from '../assets/samples/Types/suit.jpg';
import vision from '../assets/contact/contact.jpg';
import { motion } from 'framer-motion';

function About() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
    };

    return (
        <div className="about-page">
            
            {/* Section 1: Hero */}
            <div className="about-hero" style={{backgroundImage: `linear-gradient(rgba(20, 33, 61, 0.85), rgba(20, 33, 61, 0.85)), url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
                <motion.h1 className="hero-title" initial="hidden" animate="visible" variants={fadeInUp}>
                    Maviinci
                </motion.h1>
                <motion.div className="hero-subtitle" initial="hidden" animate="visible" variants={fadeInUp}>
                    CRAFTING ELEGANCE &bull; DEFINING STYLE &bull; SINCE 2024
                </motion.div>
            </div>

            {/* Section 2: Our Story */}
            <section className="about-section story-section">
                <motion.div className="section-content" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                    <div className="content-text">
                        <h2 className="section-title">Our Story</h2>
                        <p>
                            Born from the vision of Blue Pearl Industries Inc., Maviinci represents the pinnacle of bespoke tailoring. 
                            We believe that clothing is not just about covering the body, but about expressing the soul.
                        </p>
                        <p>
                            Our journey began with a simple idea: to bring the luxury of custom-made clothing to everyone, 
                            combining traditional craftsmanship with modern technology. Every stitch tells a story of dedication, 
                            precision, and passion.
                        </p>
                    </div>
                    <div className="content-image">
                        <img src={vision} alt="Our Story" />
                    </div>
                </motion.div>
            </section>

            {/* Section 3: Our Craft */}
            <section className="about-section vision-section">
                <motion.div className="section-content" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                    <div className="content-image">
                        <img src={craft} alt="Our Craft" />
                    </div>
                    <div className="content-text">
                        <h2 className="section-title">The Art of Craft</h2>
                        <p>
                            At Maviinci, we don't just make clothes; we engineer fit and style. Our artisans bring decades of experience 
                            to every garment, ensuring that each piece is a masterpiece.
                        </p>
                        <p>
                            From selecting the finest fabrics to the final fitting, our process is meticulous. 
                            We honor the traditions of bespoke tailoring while embracing contemporary designs that resonate with the modern individual.
                        </p>
                    </div>
                </motion.div>
            </section>

            {/* Section 4: Values / Join Us */}
            <section className="about-section values-section">
                <motion.div style={{textAlign: 'center', marginBottom: '4rem'}} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                    <h2 className="section-title">Our Values</h2>
                    <p style={{maxWidth: '600px', margin: '1rem auto', color: '#6b7280'}}>
                        The principles that guide every cut, every stitch, and every interaction.
                    </p>
                </motion.div>

                <div className="values-grid">
                    {[
                        { title: "Precision", desc: "Attention to the smallest detail is what separates good from great.", icon: "✨" },
                        { title: "Quality", desc: "We source only the finest materials from around the globe.", icon: "💎" },
                        { title: "Individuality", desc: "Your style is unique, and your clothes should be too.", icon: "👤" },
                        { title: "Innovation", desc: "Merging tradition with technology for the perfect fit.", icon: "🚀" }
                    ].map((item, index) => (
                        <motion.div className="value-card" key={index} 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                        >
                            <div className="value-icon">{item.icon}</div>
                            <h3 className="value-title">{item.title}</h3>
                            <p className="value-desc">{item.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </section>

        </div>
    );
}

export default About;
